// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"ad821650","787":"2522a424"}[chunkId] + ".chunk.js";
};